import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'prlw-layout-basic',
  templateUrl: './layout-basic.component.html',
  styleUrls: ['./layout-basic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LayoutBasicComponent {}
